/* CappyRoots mobile scroll fix v2 — cache-safe visual viewport compensation. */
(function () {
  var doc = document;
  var root = doc.documentElement;
  var media = window.matchMedia && window.matchMedia('(max-width: 749px)');
  var queued = false;

  function isMobile() {
    return !media || media.matches;
  }

  function updateViewportInsets() {
    queued = false;
    if (!isMobile()) {
      root.style.removeProperty('--cr-mobile-vv-bottom');
      root.style.removeProperty('--cr-mobile-vv-height');
      root.removeAttribute('data-cr-mobile-keyboard');
      return;
    }

    var viewport = window.visualViewport;
    if (!viewport) {
      root.style.setProperty('--cr-mobile-vv-bottom', '0px');
      root.style.setProperty('--cr-mobile-vv-height', Math.max(1, Math.round(window.innerHeight)) + 'px');
      root.removeAttribute('data-cr-mobile-keyboard');
      return;
    }

    var visualBottom = (viewport.offsetTop || 0) + viewport.height;
    var bottomInset = Math.max(0, Math.round(window.innerHeight - visualBottom));
    root.style.setProperty('--cr-mobile-vv-bottom', bottomInset + 'px');
    // 100vh/100dvh can still include Chrome or Safari's bottom controls on real iOS devices.
    // Publish the browser's measured visible height so fixed drawers end above that UI.
    root.style.setProperty('--cr-mobile-vv-height', Math.max(1, Math.round(viewport.height)) + 'px');

    if (viewport.height < window.innerHeight * 0.76) {
      root.setAttribute('data-cr-mobile-keyboard', 'true');
    } else {
      root.removeAttribute('data-cr-mobile-keyboard');
    }
  }

  function queueUpdate() {
    if (!queued) {
      queued = true;
      window.requestAnimationFrame(updateViewportInsets);
    }
  }

  window.addEventListener('resize', queueUpdate, { passive: true });
  window.addEventListener('orientationchange', queueUpdate, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', queueUpdate, { passive: true });
    window.visualViewport.addEventListener('scroll', queueUpdate, { passive: true });
  }
  if (media && media.addEventListener) media.addEventListener('change', queueUpdate);
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', queueUpdate, { once: true });
  else queueUpdate();
}());
